import { motion } from 'framer-motion'
import React from 'react'

import { v4 as rid } from 'uuid'
import { images } from '../../constants'
import { AppWrap } from '../../wrapper'
import './Intro.scss'

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
}

const Intro = () => (
  <div className="app__intro app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__intro-info">
      <div className="app__intro-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p>Hello, I am</p>
            <h1 className="head-text">Khoi</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex">
          <p className="p-text">Front-End Developer</p>
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__intro-img">
      <img src={images.profile} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__intro-circles">
      {[images.javascript, images.react, images.angular].map(circle => (
        <div className="circle-cmp app__flex" key={`circle_${rid()}`}>
          <img src={circle} alt="profile_bg" />
        </div>
      ))}
    </motion.div>
  </div>
)

export default AppWrap(Intro)
